import { useAppDispatch } from "../../../../../redux/hooks";
import {
  fetchPrintBinA4,
  fetchPrintBinZebra,
  fetchUndeliveredBins,
  postDeleteBin,
} from "../../../../../redux/api/expedition.api";
import { UndeliveredBinsDataInterface } from "../../../../../redux/interfaces/expedition.interface";

import CustomButton from "../../../../../components/CustomButton";
import SvgIcon from "../../../../../helpers/SvgIcon";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import { useState } from "react";

function UndeliveredBinsActionButtons({
  itemId,
  crudData,
  tableContext,
}: {
  itemId: string;
  crudData: UndeliveredBinsDataInterface;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const handlePrintBinA4 = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinA4({
          idBin: itemId,
        }),
      );
    }
  };

  const handlePrintBinZebra = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinZebra({
          idBin: itemId,
        }),
      );
    }
  };

  const handleDeleteBin = async () => {
    const resultAction = await dispatch(
      postDeleteBin({
        id_bin: crudData.id_bin,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postDeleteBin) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postDeleteBin) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        fetchUndeliveredBins({
          page: tableContext.tablePagination.page,
          perPage: tableContext.tablePagination.rowsPerPage,
          sn_bin: tableContext.tableSearch.sn_bin,
          nodDestinatie: tableContext.tableSearch.nodDestinatie,
          nodPreluare: tableContext.tableFilter.nodPreluare,
          status: tableContext.tableFilter.status,
        }),
      );
    }
  };

  return (
    <div>
      {crudData.status === 0 && (
        <CustomButton
          loading={isLoading}
          tooltipTitle="Stergere"
          variant="contained"
          color="error"
          className="mt-1 me-1"
          withConfirmationModal={{
            modalTitle: `Doriti sa stergeti binul ${crudData.sn_bin}?`,
            modalLeftButtonColor: "inherit",
            modalRightButtonOnClick: handleDeleteBin,
            modalRightButtonText: "Sterge",
            modalLeftButtonText: "Anuleaza",
          }}>
          <SvgIcon type="DELETE" className="svg-icon-2" />
        </CustomButton>
      )}

      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Print A4"
        onClick={handlePrintBinA4}>
        <SvgIcon type="PRINT_A4" fill="white" className="svg-icon-2" />
      </CustomButton>

      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Print Zebra"
        onClick={handlePrintBinZebra}>
        <SvgIcon type="PRINT_ZEBRA" className="svg-icon-2" />
      </CustomButton>
    </div>
  );
}

export default UndeliveredBinsActionButtons;
